import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Clinic } from '../shared/interfaces/clinic.model';
import { PageDataTotalTypes, PageDataScheduleTypes } from '../shared/interfaces/page-data.enum';
import { PublicApiService } from '../shared/services/public-api.service';
import { PublicService } from '../shared/services/public.service';
import { HttpApiService } from '../../../shared/services/http-api.service';

@Component({
  selector: 'app-clinics',
  templateUrl: './clinics.component.html',
  styleUrls: ['./clinics.component.scss']
})
export class ClinicsComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  
  clinics!: Clinic[];
  selectedClinic!: Clinic;
  error!: boolean; 

  constructor(
    private publicService: PublicService,
    private publicApiService: PublicApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private httpApiService: HttpApiService,
  ) {
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    if(sessionStorage.getItem("app") == "client_key"){
    this.publicApiService.postApiUser(this.httpApiService.getClientKey()).subscribe(result => {
      this.httpApiService.setApiClinicKey(result.domain)
      this.httpApiService.setApi(result.domain)
      this.getClinics();
    })
  }else
    this.getClinics()
    
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getClinics(): void {
    this.subscription.add(
      this.publicApiService.getClinics()
        .pipe(filter(x => !!x || (x as []).length))
        .subscribe((x: any) => {
          this.clinics = x;
          this.generateFormatedAddress();
          this.setPagesData();
          this.verifyNavegate();
        },
        err =>{
          this.error = true;
        })
    );
  }

  private generateFormatedAddress(): void {
    this.clinics = this.clinics.map(x => {
      return {
        ...x,
        addressFormated: this.publicService.generateFormatedAddress(
          x.address
        )
      }
    });
  }


  private setPagesData(): void {
    this.publicService.setPageDataTotal(
      PageDataTotalTypes.CLINICS_TOTAL,
      this.clinics.length
    );
  }

  private verifyNavegate(): void {
    if (this.clinics.length === 1) {
      this.publicService.setPublicScheduleSelectedData(
        PageDataScheduleTypes.CLINIC_SCHEDULE_DATA,
        this.clinics[0]
      );
      this.navigate(0);
    }
  }

  private navigate(timeout: number = 200): void {
    setTimeout(() => {
      this.router.navigate(['types'], { relativeTo: this.activatedRoute})
    }, timeout);
  }

  public isSelected(clinicId: string): boolean {
    if (!this.selectedClinic) {
      return false;
    }
    return this.selectedClinic.id === clinicId;
  }

  public clinicSelectChanged(index: number): void {
    this.selectedClinic = this.clinics[index];
    this.publicService.setPublicScheduleSelectedData(
      PageDataScheduleTypes.CLINIC_SCHEDULE_DATA,
      this.selectedClinic
    );
    this.navigate();
  }
}
